'use strict';
/**
 * Created by 陈桥 on 2016/7/13.
 * QQ:626164558
 * Email ：chen.qiao@foxmail.com
 */

import EventEmitter from './lib/eventemitter2';

export default EventEmitter;
